import { jsxs as l, jsx as n } from "react/jsx-runtime";
import e from "./styles.module.less.js";
const p = (i) => {
  const { children: r, items: s, toggleOpen: a, isOpen: c, menuWrapperRef: t } = i;
  return /* @__PURE__ */ l(
    "div",
    {
      className: `${e.mobileChatButtonContainer} ${c ? e.open : ""}`,
      ref: t,
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            className: e.mobileDropdownTriggerContainer,
            onClick: () => a(),
            children: r
          }
        ),
        /* @__PURE__ */ n("div", { className: e.mobileDropdownContainer, children: s.map(
          (o) => o.link ? /* @__PURE__ */ l(
            "a",
            {
              href: o.link,
              className: e.mobileDropdownItem,
              children: [
                o.title,
                /* @__PURE__ */ n(o.icon, { className: e.mobileDropdownItemIcon })
              ]
            },
            o.title
          ) : /* @__PURE__ */ l(
            "div",
            {
              className: e.mobileDropdownItem,
              onClick: o.onClick,
              children: [
                o.title,
                /* @__PURE__ */ n(o.icon, { className: e.mobileDropdownItemIcon })
              ]
            },
            o.title
          )
        ) })
      ]
    }
  );
};
export {
  p as MobileMenuDropdown
};
